import type { ReactNode } from 'react'

import { Layout as LayoutComponent } from '@twistopayments/design-system/components/atoms/layout'

import { useIsMobile } from '@twisto/hooks'

import { FooterCopyright } from '../footer-copyright'

import * as styles from './base-layout.styles'

type Props = {
  children: ReactNode
}

export const BaseLayout = ({ children }: Props) => {
  const isMobile = useIsMobile()

  return (
    <LayoutComponent
      screenWithAppBar
      css={styles.screen}
      direction="column"
      variant="screen"
    >
      <LayoutComponent
        grayBackground
        justify={isMobile ? 'flexStart' : 'center'}
        variant="main"
      >
        <div css={styles.content}>{children}</div>
      </LayoutComponent>
      {!isMobile && <FooterCopyright />}
    </LayoutComponent>
  )
}
